/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MigrationEligibility } from './MigrationEligibility';
import {
    MigrationEligibilityFromJSON,
    MigrationEligibilityFromJSONTyped,
    MigrationEligibilityToJSON,
    MigrationEligibilityToJSONTyped,
} from './MigrationEligibility';
import type { MigrationChangeDto } from './MigrationChangeDto';
import {
    MigrationChangeDtoFromJSON,
    MigrationChangeDtoFromJSONTyped,
    MigrationChangeDtoToJSON,
    MigrationChangeDtoToJSONTyped,
} from './MigrationChangeDto';

/**
 * 
 * @export
 * @interface MigrationPreviewDto
 */
export interface MigrationPreviewDto {
    /**
     * 
     * @type {number}
     * @memberof MigrationPreviewDto
     */
    fromVersion: number | null;
    /**
     * 
     * @type {number}
     * @memberof MigrationPreviewDto
     */
    toVersion: number;
    /**
     * 
     * @type {MigrationEligibility}
     * @memberof MigrationPreviewDto
     */
    eligibility: MigrationEligibility;
    /**
     * True if any detected change is breaking and has no playbook resolution.
     * @type {boolean}
     * @memberof MigrationPreviewDto
     */
    hasBreakingChanges: boolean;
    /**
     * 
     * @type {Array<MigrationChangeDto>}
     * @memberof MigrationPreviewDto
     */
    changes: Array<MigrationChangeDto>;
    /**
     * Element references flagged for re-answering after migration (non-blocking).
     * @type {Array<string>}
     * @memberof MigrationPreviewDto
     */
    flaggedReferences: Array<string>;
}



/**
 * Check if a given object implements the MigrationPreviewDto interface.
 */
export function instanceOfMigrationPreviewDto(value: object): value is MigrationPreviewDto {
    if (!('fromVersion' in value) || value['fromVersion'] === undefined) return false;
    if (!('toVersion' in value) || value['toVersion'] === undefined) return false;
    if (!('eligibility' in value) || value['eligibility'] === undefined) return false;
    if (!('hasBreakingChanges' in value) || value['hasBreakingChanges'] === undefined) return false;
    if (!('changes' in value) || value['changes'] === undefined) return false;
    if (!('flaggedReferences' in value) || value['flaggedReferences'] === undefined) return false;
    return true;
}

export function MigrationPreviewDtoFromJSON(json: any): MigrationPreviewDto {
    return MigrationPreviewDtoFromJSONTyped(json, false);
}

export function MigrationPreviewDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MigrationPreviewDto {
    if (json == null) {
        return json;
    }
    return {
        
        'fromVersion': json['fromVersion'],
        'toVersion': json['toVersion'],
        'eligibility': MigrationEligibilityFromJSON(json['eligibility']),
        'hasBreakingChanges': json['hasBreakingChanges'],
        'changes': ((json['changes'] as Array<any>).map(MigrationChangeDtoFromJSON)),
        'flaggedReferences': json['flaggedReferences'],
    };
}

export function MigrationPreviewDtoToJSON(json: any): MigrationPreviewDto {
    return MigrationPreviewDtoToJSONTyped(json, false);
}

export function MigrationPreviewDtoToJSONTyped(value?: MigrationPreviewDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fromVersion': value['fromVersion'],
        'toVersion': value['toVersion'],
        'eligibility': MigrationEligibilityToJSON(value['eligibility']),
        'hasBreakingChanges': value['hasBreakingChanges'],
        'changes': ((value['changes'] as Array<any>).map(MigrationChangeDtoToJSON)),
        'flaggedReferences': value['flaggedReferences'],
    };
}

